var _path, _path2, _circle, _path3, _path4;
import { useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import Typography from "../../atoms/Typography";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ItemPre = width => {
  return /*#__PURE__*/_jsxs("svg", {
    width: width,
    height: width,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
      fill: "#0169B2"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 6.66602C12.5523 6.66602 13 7.11373 13 7.66602V11.5851L15.4154 14.0006C15.806 14.3911 15.806 15.0243 15.4154 15.4148C15.0249 15.8053 14.3918 15.8053 14.0012 15.4148L11.2929 12.7065C11.1054 12.5189 11 12.2646 11 11.9993V7.66602C11 7.11373 11.4477 6.66602 12 6.66602Z",
      fill: "white"
    }))]
  });
};
export const ItemBonus = width => {
  return /*#__PURE__*/_jsxs("svg", {
    width: width,
    height: width,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [_circle || (_circle = /*#__PURE__*/_jsx("circle", {
      cx: "12",
      cy: "12",
      r: "12",
      fill: "#60B883"
    })), _path3 || (_path3 = /*#__PURE__*/_jsx("path", {
      d: "M10.3397 7.5722C11.0786 6.24672 11.448 5.58398 12.0003 5.58398C12.5527 5.58398 12.9221 6.24672 13.661 7.5722L13.8521 7.91512C14.0621 8.29178 14.1671 8.48011 14.3308 8.60437C14.4945 8.72863 14.6983 8.77476 15.1061 8.86701L15.4773 8.951C16.9121 9.27564 17.6295 9.43796 17.8002 9.98683C17.9708 10.5357 17.4818 11.1076 16.5036 12.2514L16.2505 12.5474C15.9726 12.8724 15.8336 13.0349 15.7711 13.236C15.7085 13.437 15.7296 13.6539 15.7716 14.0876L15.8098 14.4824C15.9577 16.0085 16.0317 16.7716 15.5848 17.1108C15.138 17.45 14.4663 17.1407 13.1228 16.5222L12.7753 16.3621C12.3935 16.1864 12.2027 16.0985 12.0003 16.0985C11.798 16.0985 11.6071 16.1864 11.2254 16.3621L10.8778 16.5222C9.53439 17.1407 8.86268 17.45 8.41583 17.1108C7.96898 16.7716 8.04292 16.0085 8.19081 14.4824L8.22907 14.0876C8.27109 13.6539 8.2921 13.437 8.22958 13.236C8.16706 13.0349 8.02807 12.8724 7.75011 12.5474L7.49705 12.2514C6.51889 11.1076 6.02981 10.5357 6.20049 9.98683C6.37117 9.43796 7.08858 9.27564 8.52339 8.951L8.89459 8.86701C9.30232 8.77476 9.50619 8.72863 9.66988 8.60437C9.83357 8.48011 9.93855 8.29178 10.1485 7.91512L10.3397 7.5722Z",
      fill: "white"
    }))]
  });
};
export default function EditionContentItem(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const {
    listShowEdition,
    description,
    titleContent
  } = props;
  const Item = width => {
    return /*#__PURE__*/_jsx("svg", {
      width: width,
      height: width,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: _path4 || (_path4 = /*#__PURE__*/_jsx("path", {
        d: "M23.6299 12.005C23.6299 5.63 18.3799 0.380005 12.0049 0.380005C5.58301 0.380005 0.379883 5.63 0.379883 12.005C0.379883 18.4269 5.58301 23.63 12.0049 23.63C18.3799 23.63 23.6299 18.4269 23.6299 12.005ZM10.6455 18.1925C10.3643 18.4738 9.84863 18.4738 9.56738 18.1925L4.69238 13.3175C4.41113 13.0363 4.41113 12.5206 4.69238 12.2394L5.77051 11.2081C6.05176 10.88 6.52051 10.88 6.80176 11.2081L10.1299 14.4894L17.1611 7.45813C17.4424 7.13 17.9111 7.13 18.1924 7.45813L19.2705 8.48938C19.5518 8.77063 19.5518 9.28625 19.2705 9.5675L10.6455 18.1925Z",
        fill: "#00B0B8"
      }))
    });
  };
  const renderItem = item => {
    if (!item || item === "0") {
      return "";
    }
    const newItem = `${item}`.toLowerCase();
    if (isMobile) {
      if (newItem === "1") {
        return Item(16);
      }
      if (newItem === "p") {
        return ItemPre(16);
      }
      if (newItem === "e") {
        return ItemBonus(16);
      }
    }
    if (newItem === "p") {
      return ItemPre(24);
    }
    if (newItem === "e") {
      return ItemBonus(24);
    }
    return Item(24);
  };
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      width: "100%",
      display: "flex",
      gap: "16px",
      justifyContent: "space-between"
    },
    children: [/*#__PURE__*/_jsxs(Box, {
      sx: {
        flex: 1,
        display: "flex",
        flexWrap: "wrap",
        maxWidth: {
          xs: "140px",
          md: "358px"
        },
        width: {
          xs: "140px",
          md: "314px"
        },
        padding: {
          xs: "12px 18px",
          md: "20px 22px"
        }
      },
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "p3",
        sx: {
          lineHeight: {
            xs: "22px",
            md: "24px"
          }
        },
        children: titleContent
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "p3",
        color: "#9F9F9F",
        children: description
      })]
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        display: "flex",
        flex: 1,
        justifyContent: "flex-end",
        gap: "16px"
      },
      children: !!listShowEdition?.length && listShowEdition.map((item, index) => {
        return /*#__PURE__*/_jsx(Box, {
          sx: {
            width: {
              xs: "118px",
              md: "134px"
            },
            overflow: "hidden",
            padding: {
              xs: "15px 14px",
              md: "20px 24px"
            },
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          },
          children: renderItem(item)
        }, index);
      })
    })]
  });
}